type EmptyProps = Record<string, never>;
export enum MODULES {
  CONSUMER_PRODUCT_STYLES = 'consumer-product-styles',
  NAVIGATION_BUTTONS = 'navigation-buttons',
}
export type BottomNavbarModuleProps = {
  [MODULES.CONSUMER_PRODUCT_STYLES]: EmptyProps;
  [MODULES.NAVIGATION_BUTTONS]: { isHidden: boolean };
};
